import { useState, useCallback } from 'react';
import { convertToElevarDataItem } from '../utils';

const useVisibleProducts = (products, location, initialProductListAmount) => {
  const [impressions, setImpressions] = useState([]);
  const [fullProductListVisible, setFullProductListVisible] = useState([]);

  const handleLoadMore = useCallback(
    (newNumberOfVisibleItems) => {
      try {
        const newVisibleItems = products.slice(
          fullProductListVisible.length,
          newNumberOfVisibleItems
        );

        setFullProductListVisible((prevState) => [...prevState, ...newVisibleItems]);

        const updatedImpressions = [
          ...impressions,
          ...newVisibleItems.map((product, index) => convertToElevarDataItem({
            item: product,
            index: impressions.length + index,
            location,
          })),
        ];

        setImpressions(updatedImpressions);
      } catch (error) {
        console.error('Error in handleLoadMore:', error);
      }
    },
    [impressions, products, location]
  );

  const handleFilteredProducts = useCallback(
    (newProducts) => {
      try {
        const uniqueProducts = newProducts.filter(
          (product) => !impressions.some((p) => p.id === product.id)
        );

        const filteredImpressions = uniqueProducts.map((product, index) => convertToElevarDataItem({
          item: product,
          index: impressions.length + index,
          location,
        }));

        setImpressions((prevImpressions) => [...prevImpressions, ...filteredImpressions]);
      } catch (error) {
        console.error('Error in handleFilteredProducts:', error);
      }
    },
    [impressions, location]
  );

  return {
    impressions,
    handleLoadMore,
    handleFilteredProducts,
    initialProductListAmount,
  };
};

export default useVisibleProducts;
